// src/admin/components/AdminModal.jsx
import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default function AdminModal({
  show,
  onClose,
  title,
  children,
  footer,
  size = 'lg', // 'sm' | '' | 'lg' | 'xl'
  backdrop = 'static',
}) {
  if (!show) return null;

  const dialogClass = classNames('modal-dialog modal-dialog-centered', {
    'modal-sm': size === 'sm',
    '': size === '',
    'modal-lg': size === 'lg',
    'modal-xl': size === 'xl',
  });

  // Portal to document.body so modals aren't trapped in parent stacking
  // contexts (e.g. the sticky admin sidebar vs. main dashboard content).
  return createPortal(
    <>
      <div
        className="modal fade show"
        style={{ display: 'block' }}
        tabIndex="-1"
        data-bs-backdrop={backdrop}
        aria-modal="true"
        role="dialog"
      >
        <div className={dialogClass}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
              <button type="button" className="btn-close" onClick={onClose} aria-label="Close" />
            </div>
            <div className="modal-body">{children}</div>
            {footer && <div className="modal-footer w-100">{footer}</div>}
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>,
    document.body,
  );
}

AdminModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  children: PropTypes.node,
  footer: PropTypes.node,
  size: PropTypes.oneOf(['sm', '', 'lg', 'xl']),
  backdrop: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
};

AdminModal.defaultProps = {
  children: null,
  footer: null,
  size: 'lg',
  backdrop: 'static',
};
